import CurrencyFormatter from './CurrencyFormatter';
import { GridFormatterControlsProps } from './GridFormatter.props';
import { StyledRoot } from './GridFormatter.styles';
import UnitsFormatter from './UnitsFormatter';

const GridFormatterControls = ({
  currency,
  currencyFormatter,
  currencyLabel,
  isLoading,
  onCurrencyChanged,
  onUnitsChanged,
  sx,
  unitsFormatter,
  unitsLabel,
}: GridFormatterControlsProps) => (
  <StyledRoot sx={sx}>
    {currencyFormatter ? (
      <CurrencyFormatter
        currency={currency}
        isLoading={isLoading}
        label={currencyLabel}
        onCurrencyChanged={onCurrencyChanged}
      />
    ) : null}
    {unitsFormatter ? (
      <UnitsFormatter
        currency={currency}
        isLoading={isLoading}
        label={unitsLabel}
        onUnitsChanged={onUnitsChanged}
      />
    ) : null}
  </StyledRoot>
);

export default GridFormatterControls;
